import styled, { css } from 'styled-components';

import Section from 'Elements/Section';

export const StyledSection = styled(Section)`
    ${({ theme }) => css`
        &&&& article {
            z-index: 12;
            margin-top: -4.75rem;

            @media ${theme.breakpoints.medium.media} {
                margin-top: -3.75rem;
            }
            @media ${theme.breakpoints.large.media} {
                margin-top: -4.75rem;
            }
        }
    `}
`;
